import './css/ecf_get_quarterly.scss'
import './js/ecf_get_quarterly'